document.addEventListener("DOMContentLoaded", function() {
    
    // Change actibe block on desktop 
    function changeActiveBlockDesktop(target) {
        const clickedDotIndex = target.getAttribute('data-index');
        // console.log(target, clickedDotIndex); 

        const blockElements = document.querySelectorAll('.shop_the_look-product_dot, .shop-the-look_dot-hotspot, .shop_the_look-block');

        blockElements.forEach(function(element) {
            if (element.getAttribute('data-index') === clickedDotIndex) {
                element.classList.add('block-active');
            } else {
                element.classList.remove('block-active');
            }
        });
    }


    function moveIntoFocusMobile(target) {
        // Remove any previous code
        closePopup();

        // Display active index
        clickedDotIndex = target.getAttribute('data-index');
        // console.log(this, clickedDotIndex);

        const mobileBlockElements = document.querySelectorAll('.shop-the-look_dot-hotspot, .mobile_shop-the-look_item-product, .mobile_shop-the-look_item-product .shop_the_look-block');
        mobileBlockElements.forEach(function(element) {
            if (element.getAttribute('data-index') === clickedDotIndex) {
                element.classList.add('block-active');
            } else {
                element.classList.remove('block-active');
            }
        });

        // Prevent user from scrolling
        document.documentElement.classList.add('lock');

        // Declare frequently used variables
        const shopthelookPopUpBase = document.querySelector('.shop-the-look_mobile-pop-up_base');
        const image = document.querySelector('.image-with-text__image-column.move-into-focus');
        // console.log(shopthelookPopUpBase)


        // Add background to all of visible viewport
        const shopTheLookSection = document.querySelector('.shop-the-look-section');
        shopTheLookSection.classList.add('in-focus');
        
        // Hide button
        document.querySelector('.image-with-text-overlay__buttons.shop-the-look-section').style.display = "none";

        // Create base element for product cards
        let shopthelookPopUp = document.querySelector('#shopthelook_popup-base');

        if (!shopthelookPopUp) {
            shopthelookPopUp = document.createElement('div');
            shopthelookPopUp.id = "shopthelook_popup-base";
            shopthelookPopUp.classList.add("active");
            document.body.appendChild(shopthelookPopUp);
            shopthelookPopUp.appendChild(shopthelookPopUpBase);    

        } else {
            shopthelookPopUp.classList.add("active");
        }


        // Set image to the top and fill out entire width of screen
        const scaleFactor = window.innerWidth / image.offsetWidth;
        const rect = image.getBoundingClientRect();

        let translateY;
        // Check whether image and modal overflow
        const sectionsHeight = image.offsetHeight + shopthelookPopUpBase.offsetHeight; 
        // console.log(image.offsetHeight, shopthelookPopUpBase.offsetHeight);
        // If overflow then reduce translateY with overflow + 20
        if (sectionsHeight > window.innerHeight) {
            translateY = -rect.top - (20 + sectionsHeight - window.innerHeight);
            console.log(sectionsHeight, window.innerHeight);
        // Else set image top to screen top
        } else {
            translateY = -rect.top;
        }
        image.style.cssText = `
            transform: translateY(${translateY}px) scale(${scaleFactor});
            z-index: 100;
            `
    }


    // Close popup
    function closePopup() {

        // Scrollable
        document.documentElement.classList.remove('lock');

        // Remove background opacity from port
        const shopTheLookSection = document.querySelector('.shop-the-look-section');
        if (shopTheLookSection) {
        shopTheLookSection.classList.remove('in-focus');
        }
        
        // Remove Modal
        const existingPopup = document.getElementById("shopthelook_popup-base");
        if (existingPopup) {
            existingPopup.classList.remove('active');
        }

        // Show button
        document.querySelector('.image-with-text-overlay__buttons.shop-the-look-section').style.display = "flex";
        
        // Set image back to normal 
        const image = document.querySelector('.image-with-text__image-column.move-into-focus');

        image.style.cssText = `
        transform: none;
        z-index: auto;
        `
    }

    // Check screen size
    function isMobile() {
        return window.innerWidth <= 798
    }


    const productDots = document.querySelectorAll('.shop_the_look-product_dot');
    const hotspotDots = document.querySelectorAll('.shop-the-look_dot-hotspot');
    

    productDots.forEach(function(dot) {
        dot.addEventListener('click', function(event) {
            changeActiveBlockDesktop(event.currentTarget)
        });
    });

    // Attach the event listener to all hotspot dots
    hotspotDots.forEach(function(dot) {
            dot.addEventListener('click', function(event) {
                if (isMobile()) {
                    moveIntoFocusMobile(event.target)
                } else {
                    changeActiveBlockDesktop(event.target)
                }
            })     
    });
    
    // View products button
    document.querySelector('.shop-the-look-section .button').addEventListener('click', function(event) {
        moveIntoFocusMobile(event.target);
    })

    // Exit focus mode mobile
    document.querySelector('#exit_zoom').addEventListener('click', closePopup)

});
